export const setAppList = (state, data) => {
    /* the app list is made up of data from two sepparate APIs
     data.detailed contains general information about the app of which applicationId is what interests us here
     data.install contains information about the version of the app. The app corresponding to each object is determined through the applicationId */
    for (const app of data.detailed) {
        const appInfo = data.install.filter(info => info.applicationId === app.applicationId)[0];
        let appObj;
        let needToBeUpdated;

        /* if the object corresponding the app does not have the installedApplicationRevisionId set then the app is not installed */
        if (appInfo && appInfo.installedApplicationRevisionId) {
            needToBeUpdated = false;

            /* if the installedApplicationRevisionId is not the same as the id of the first revision in the revisions array of the app it means
         that the app needs to be updated */
            if (appInfo.installedApplicationRevisionId !== app.revisions[0].applicationRevisionId) {
                needToBeUpdated = true;
            }

            appObj = {
                ...app,
                ...appInfo,
                installed: true,
                needToBeUpdated
            };
        } else {
            appObj = {
                ...app,
                installed: false,
                needToBeUpdated
            };
        }

        /* after we mold the data in to something easy to use we push it to our state array */
        state.appList.push(appObj);
    }
    state.loadingApps = false;
};

export const uninstallApp = (state, app) => {
    app.installed = false;
};

export const installApp = (state, app) => {
    app.installed = true;
};

export const updateApp = (state, app) => {
    app.needToBeUpdated = false;
};
